import { render } from "./UpdateReviewerModel.vue?vue&type=template&id=04d586c0&scoped=true"
import script from "./UpdateReviewerModel.js?vue&type=script&lang=js"
export * from "./UpdateReviewerModel.js?vue&type=script&lang=js"

import "./UpdateReviewerModel.vue?vue&type=style&index=0&id=04d586c0&lang=scss"
import "./UpdateReviewerModel.vue?vue&type=style&index=1&id=04d586c0&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d586c0"]])

export default __exports__